import {
  NotificationPreferenceInputData,
  NotificationPreferenceResponse,
  UserNotificationRoleResponse,
} from 'src/graphql/entities/notification-preference/notifications.types';
import { WithTypeName } from 'src/graphql/types';
import { NotificationEventResponse } from './use-get-notification-events';
import { NotificationRoleResponse } from './use-get-notification-roles';

export const inputDataToNotificationPreference = (
  input: NotificationPreferenceInputData,
  {
    userId,
    partnerId,
  }: {
    userId: string;
    partnerId: number;
  },
  mappers: {
    notificationEventsMap: Map<string, NotificationEventResponse>;
    notificationRolesMap: Map<string, NotificationRoleResponse>;
  },
): WithTypeName<NotificationPreferenceResponse> => {
  return {
    __typename: 'NotificationPreference',
    id: input.notificationPreferenceId,
    notificationPreferenceId: input.notificationPreferenceId,
    notificationEventId: input.notificationEventId,
    notificationChannelId: input.notificationChannelId,
    isActive: input.isActive,
    partnerId,
    userId,
    notificationEvent: mappers.notificationEventsMap.get(input.notificationEventId)!,
    userNotificationRole: [
      ...(input.userNotificationRole?.map<WithTypeName<UserNotificationRoleResponse>>(
        (unr) => {
          return {
            __typename: 'UserNotificationRole',
            id: unr.userNotificationRoleId,
            userNotificationRoleId: unr.userNotificationRoleId,
            notificationPreferenceId: input.notificationPreferenceId,
            isActive: unr.isActive,
            notificationRoleId: unr.notificationRoleId,
            notificationRole: mappers.notificationRolesMap.get(unr.notificationRoleId)!,
            userId,
            partnerId,
          };
        },
      ) ?? []),
    ],
  };
};
